import React from 'react';
import * as Styled from './styled';
import LeadingHoodIcon from 'assets/svg/leading-hood.svg';
import LeadingCheckIcon from 'assets/svg/leading-check.svg';
import { useLocale } from 'locale';

interface LeadingAgentInfoProps {
  neighbourhoods: Array<{
    ref: {
      name: string;
      docId: string;
    };
  }>;
  agentStatement: string;
  isMobile?: boolean;
}

export const LeadingAgentInfo: React.FC<LeadingAgentInfoProps> = (props) => {
  const {
    neighbourhoods,
    agentStatement,
    isMobile = false,
  } = props;

  const { t } = useLocale();
  const neighbourhoodsList = React.useMemo(() => neighbourhoods.map(n => n.ref.name), [ neighbourhoods ]);
  const hoodTitle = t('leading.agent.hood.title');

  return (
    <Styled.Root isMobile={isMobile}>
      <Styled.Card isMobile={isMobile}>
        <Styled.CardInner isMobile={isMobile}>
          <Styled.Title>
            <Styled.TitleIconWrapper isMobile={isMobile}><LeadingCheckIcon /></Styled.TitleIconWrapper>
            {t('leading.agent.info', { length: neighbourhoodsList.length, neighbourhood: neighbourhoodsList[0].split(',')[0]  })}
          </Styled.Title>
          {isMobile ? <Styled.MobileStatement small>{agentStatement}</Styled.MobileStatement> : <Styled.Statement>{agentStatement}</Styled.Statement>}
          {neighbourhoodsList.length > 1 ? (
            <Styled.HoodsSection>
              <Styled.HoodTitle weight="bold">{hoodTitle}</Styled.HoodTitle>
              <Styled.HoodList>
                {neighbourhoodsList.map(hood => hood ? <Styled.HoodItem small key={hood}>{hood}</Styled.HoodItem> : null)}
              </Styled.HoodList>
            </Styled.HoodsSection>
          ) : null}
        </Styled.CardInner>
        <LeadingHoodIcon className="hood-icon" />
      </Styled.Card>
    </Styled.Root>
  );
};
